import { parseBooleanString } from "../../../util/utility";
import { CXoneAgentEvent } from '../agent/cxone-agent-event';
/**
 * Model class for agent session end event
 */
export class AgentSessionEndEvent extends CXoneAgentEvent {
  /**
   * @remarks - 
   */
  public message!: string;


  /**
   * @remarks - 
   */
  public success!: boolean;

  /**
   * The parse method will take the data object and assign the values to the AgentSessionEnd class properties
   * @param data - Data object received
   * @example -
   * ```
   * parse(data);
   * ```
   */
  public parse(data: { [key: string]: string }): void {
    this.iisHost = data.IISHost;
    this.vcHost = data.VCHost;
    this.message = data.Message;
    this.success = parseBooleanString(data.Success);
  }
}
